import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class MultiquoteMobilityPermissions extends BaseScenesPermissions {}

export default MultiquoteMobilityPermissions
